<template>
  <div class="image-messgae">
    <BaseMessageBubble class="BaseMessageBubble">
      <img v-if="options.type === 'TIMImageElem'" :src="options.src ? options.src : options.payload.imageInfoArray[0].imageUrl" @click="viewImage" />
      <img v-else-if="payload.customType === 'image' && payload.childType === 'sendImage'" :src="payload.data.url" />
    </BaseMessageBubble>
    <BaseProgress v-if="options.progress && options.progress !== 100" :percentage="options.progress" :color="options.progress === 100 ? '#67c23a' : '#409eff'">
    </BaseProgress>
  </div>
</template>

<script>
import BaseMessageBubble from './BaseMessageBubble.vue'
import BaseProgress from './BaseProgress.vue'
export default {
  name: 'imageMessage',
  components: {
    BaseMessageBubble,
    BaseProgress
  },
  data () {
    return {
    }
  },
  props: {
    options: {
      type: Object,
      default: () => { }
    }
  },
  computed: {
    payload: function () {
      return JSON.parse(this.options.payload.data)
    }
  },
  mounted () { },
  methods: {
    viewImage () {
      let images = []
      if (this.options.src) {
        images.push(this.options.src)
      } else {
        images.push(this.options.payload.imageInfoArray[0].imageUrl)
      }
      this.$viewerApi({
        images
      })
    }
  }
}
</script>

<style>
.BaseMessageBubble > img {
  max-width: 100%;
}
</style>
